class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.leaveTimeout = null; // 用于存储延迟计时器

    // 添加事件监听器以实现悬停功能
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    // 监听点击事件，以便在移动设备上正常工作
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
  
  // 处理点击事件，防止桌面悬停和点击冲突
  onSummaryClick(event) {
    // 如果是桌面悬停设备，则阻止点击的默认行为，因为悬停已经处理了
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.innerWidth >= 990) {
      event.preventDefault();
    }
  }

  // 鼠标进入事件处理
  onMouseEnter() {
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.innerWidth >= 990) {
      clearTimeout(this.leaveTimeout); // 清除可能存在的关闭计时器
      
      // 关闭其他已打开的菜单
      document.querySelectorAll('header-menu details[open]').forEach((detail) => {
        if (detail !== this.mainDetailsToggle) {
          detail.removeAttribute('open');
        }
      });

      this.mainDetailsToggle.setAttribute('open', '');
    }
  }

  // 鼠标离开事件处理
  onMouseLeave() {
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.innerWidth >= 990) {
      // 设置一个短暂的延迟后关闭菜单
      // 这给了用户足够的时间将鼠标从菜单标题移动到下拉内容上
      this.leaveTimeout = setTimeout(() => {
        this.mainDetailsToggle.removeAttribute('open');
      }, 150); // 150毫秒延迟
    }
  }
}

customElements.define('header-menu', HeaderMenu);
